import { getElementByUuid } from "utils/data/Content";

export const getStorefrontUrl = function (project_uuid, projects) {
  let base_url = "";
  const project = getElementByUuid(project_uuid, projects);
  if (project) {
    base_url = project.base_url;
  }
  return base_url;
};

export const validateSocialNetworkLinks = function (
  social_network_links,
  t,
  errorMessages,
) {
  if (social_network_links) {
    const links = {};
    social_network_links.forEach((it) => {
      if (it.uid) {
        links[it.social_network] = it.uid;
      }
    });
    if (links.instagram) {
      const instagramRegex = /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,29}$/i;
      if (!instagramRegex.test(links.instagram)) {
        errorMessages.push(t("editor-errors:invalidInstagramUid"));
      }
    }
    if (links.facebook) {
      const instagramRegex = /^[a-z\d.]{5,}$/i;
      if (!instagramRegex.test(links.facebook)) {
        errorMessages.push(t("editor-errors:invalidFacebookUid"));
      }
    }
    if (links.twitter) {
      const instagramRegex = /^@?(\w){1,15}$/i;
      if (!instagramRegex.test(links.twitter)) {
        errorMessages.push(t("editor-errors:invalidTwitterUid"));
      }
    }
  }
};
